import React from 'react';
import { Container, Typography, Grid, Card, CardContent, Box, Stack } from '@mui/material';
import SecurityIcon from '@mui/icons-material/Security';
import SchoolIcon from '@mui/icons-material/School';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';

const serviceData = [
  {
    title: 'KVKK Danışmanlığı',
    description:
      'Veri envanteri, aydınlatma metinleri, saklama-imha süreçleri ve kurumsal iş akışları için teknik ve idari danışmanlık sağlıyoruz.',
    icon: SecurityIcon,
    color: '#59d0ff',
    eyebrow: 'Uyum Yönetimi',
  },
  {
    title: 'Eğitim Programları',
    description:
      'Çalışan farkındalığı, iç prosedürlerin uygulanması ve ekiplerin sorumluluk alanlarını netleştiren KVKK ve bilgi güvenliği eğitimleri sunuyoruz.',
    icon: SchoolIcon,
    color: '#8fe1ff',
    eyebrow: 'Farkındalık',
  },
  {
    title: 'Bilgi Güvenliği',
    description:
      'Kişisel verilerin korunması için gerekli erişim, loglama, yedekleme, ağ güvenliği ve süreç denetimi altyapısını birlikte tasarlıyoruz.',
    icon: VerifiedUserIcon,
    color: '#35b8ea',
    eyebrow: 'Teknik Altyapı',
  },
];

const Services = () => {
  return (
    <Box
      sx={{
        py: { xs: 8, md: 12 },
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '10%',
          left: '-10%',
          width: 420,
          height: 420,
          background: 'radial-gradient(circle, rgba(89, 208, 255, 0.18) 0%, transparent 72%)',
          zIndex: 0,
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          bottom: '-12%',
          right: '-8%',
          width: 360,
          height: 360,
          background: 'radial-gradient(circle, rgba(38, 84, 146, 0.28) 0%, transparent 70%)',
          zIndex: 0,
        }}
      />

      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        <Stack spacing={2} sx={{ mb: 6, maxWidth: 760 }}>
          <Typography
            sx={{
              color: 'primary.main',
              fontSize: '0.95rem',
              fontWeight: 700,
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
            }}
          >
            Hizmetlerimiz
          </Typography>
          <Typography variant="h2" component="h2">
            Kurumunuza uygun, uygulamaya dönük güvenlik katmanı
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Güçlü bir görsel sistemin içine, kurumların gerçek ihtiyacına cevap veren hizmet
            mimarisini yerleştirdik. Odak, yalnızca şık görünüm değil; net mesaj ve güven hissi.
          </Typography>
        </Stack>

        <Grid container spacing={4}>
          {serviceData.map((service) => (
            <Grid item xs={12} md={4} key={service.title}>
              <Card
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  transition: 'all 0.35s ease-in-out',
                  '&:hover': {
                    transform: 'translateY(-10px)',
                    borderColor: 'rgba(89, 208, 255, 0.32)',
                    boxShadow: '0 32px 70px rgba(8, 15, 34, 0.6)',
                  },
                  position: 'relative',
                  overflow: 'hidden',
                }}
              >
                <Box
                  sx={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    width: '220px',
                    height: '220px',
                    background: `radial-gradient(circle at 100% 0%, ${service.color}30 0%, transparent 72%)`,
                    borderRadius: '0 0 0 100%',
                  }}
                />

                <CardContent sx={{ p: 4, flex: 1, zIndex: 1 }}>
                  <Typography
                    sx={{
                      color: service.color,
                      fontSize: '0.8rem',
                      fontWeight: 700,
                      letterSpacing: '0.08em',
                      textTransform: 'uppercase',
                      mb: 2.5,
                    }}
                  >
                    {service.eyebrow}
                  </Typography>

                  <Box
                    sx={{
                      display: 'inline-flex',
                      p: 1.6,
                      borderRadius: '18px',
                      bgcolor: `${service.color}12`,
                      border: `1px solid ${service.color}25`,
                      color: service.color,
                      mb: 3,
                    }}
                  >
                    <service.icon sx={{ fontSize: 40 }} />
                  </Box>

                  <Typography
                    variant="h5"
                    component="h3"
                    gutterBottom
                    sx={{ color: 'text.primary', fontWeight: 600 }}
                  >
                    {service.title}
                  </Typography>

                  <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{ lineHeight: 1.8, mb: 3 }}
                  >
                    {service.description}
                  </Typography>

                  <Typography sx={{ color: 'rgba(248, 251, 255, 0.82)', fontWeight: 600 }}>
                    Detaylı süreç planı
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Services;
